import { Theme, makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme: Theme) => ({
  title: {
    fontFamily: "Inter",
    fontSize: theme.typography.pxToRem(22),
    fontWeight: 600,
  },
  test: {
    height: "600px",
  },
  card: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    width: "361px",
    height: "361px",
    marginTop: "10px",
    cursor: "pointer",
  },
  square: {
    backgroundColor: "#235693",
    borderRadius: "8px",
    height: "326px",
  },
  text: {
    color: "#FFFFFF",
    fontFamily: "Inter",
    fontWeight: 600,
    fontSize: "30px",
    lineHeight: "42px",
    margin: "24px 24px 0px 24px",
    height: "84px",
  },
  quickWins: {
    display: "flex",
    alignItems: "center",
    margin: "12px 0px 0px 24px",
  },
  quickWinsText: {
    color: "#FFFFFF",
    fontFamily: "Lato",
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "19px",
  },
  overlay: {
    marginTop: "-150px",
  },
  learningPaths: {
    display: "flex",
    flexWrap: "wrap",
    gap: "24px",
  },
}));
